import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { DatePickerFigo } from '../../common/DatePickerFigo';
import { PetCloudInputErrorLabel } from '../../common/petCloud/PetCloudInput';
import { ErrorAlert } from './ErrorAlert';

import { useDateOfHireForm } from './hooks/useDateOfHireForm';

import styles from './VerifyDateOfHireScreen.module.css';

const VerifyDateOfHireScreen = ({
  certificates = [],
  email = '',
  setCertificateNumber = () => { },
  setCurrentStep = () => { },
  setRegisteredEmail = () => { },
}) => {
  const { t } = useTranslation('petDemos');

  const {
    dateOfHire,
    dateOfHireError,
    handleDateChange,
    handleDateOfHireBlur,
    handleSubmit,
    isLinkingEmailDirectly,
    showError,
  } = useDateOfHireForm({
    certificates,
    email,
    setCertificateNumber,
    setCurrentStep,
    setRegisteredEmail,
  });

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>
          {t('certificateLinking.verifyDateOfHire.title')}
        </h1>

        <p className={styles.description}>
          <Trans
            components={{ bold: <span className={styles.bold} /> }}
            i18nKey="certificateLinking.verifyDateOfHire.description"
            ns="petDemos"
          />
        </p>
      </div>

      {showError && (
        <div className={styles.alertContainer}>
          <ErrorAlert />
        </div>
      )}

      <div className={styles.inputContainer} data-error={showError}>
        <div className={styles.datePickerContainer}>
          <span className={styles.label}>
            {t('certificateLinking.verifyDateOfHire.label')}
          </span>

          <DatePickerFigo
            classContainer={styles.datePickerInput}
            minDate={null}
            name="date-of-hire"
            onBlur={handleDateOfHireBlur}
            onDateChange={handleDateChange}
            selectedDate={dateOfHire}
          />

          <PetCloudInputErrorLabel error={dateOfHireError} />
        </div>

        <button
          className={styles.submitButton}
          disabled={isLinkingEmailDirectly}
          onClick={handleSubmit}
          type="button"
        >
          {t('certificateLinking.verifyDateOfHire.submit')}
        </button>
      </div>
    </div>
  );
};

export { VerifyDateOfHireScreen };
